export default __webpack_public_path__ + "static/media/SmallLogoSVG.8c6b31ab.svg";